import React, { type FC } from 'react'
import clsx from 'clsx';

import './Logo.scss';

interface LogoSmallProps {
    className?: string
}

export const LogoSmall: FC<LogoSmallProps> = ({className}) => {
    return (
        <div data-testid="logo-wrapper" className={clsx('logos_wrapper', className)}>
            <picture data-testid="logo-picture">
                <source srcSet={`/images/favicon_white.svg`} media="(prefers-color-scheme: dark)" />
                <source srcSet={`/images/favicon.svg`} media="(prefers-color-scheme: light)" />
                <img height={48} src={`/images/favicon.svg`} alt={'Logo'} />
            </picture>
        </div>
    );
}